/**
 * Label photos (owner request, 2026-10-11; cellar schema version 8): the front and the back of
 * the bottle, from "Scanner la bouteille" or taken on the wine's page. The cellar document only
 * names each photo; the JPEG is stored next to it, at `cellars/{cellar}/photos/{photo}.jpg`,
 * which only that cellar's person (and the owner) may read or write (infra/lib/permissions.ts).
 */

export type LabelSide = 'front' | 'back';

/** The names of a wine's label photos; a side without a photo is left out. */
export interface LabelPhotos {
  front?: string;
  back?: string;
}

/** A photo's name: letters, digits and dashes only (a UUID), so it can never escape its folder. */
export function isPhotoId(id: string): boolean {
  return /^[A-Za-z0-9-]{8,64}$/.test(id);
}

/** Where a cellar's photo is stored. */
export function labelPhotoPath(cellarId: string, photoId: string): string {
  if (!isPhotoId(photoId)) throw new Error('Nom de photo invalide.');
  return `cellars/${cellarId}/photos/${photoId}.jpg`;
}
